import { Component, Input, OnInit } from '@angular/core';
import {
    Configurations,
    Stops,
} from '@features/lazy-image/components/lazy-picture/lazy-picture.component';
import { ImageOrientation } from '@features/trips/components/trips-trip-other-trips-item/trips-trip-other-trips-item.component';
import { Asset } from '@generated/graphql';
import { LazyPictureComponent } from '../../../lazy-image/components/lazy-picture/lazy-picture.component';

@Component({
    selector: 'app-trips-itinerary-gallery-item',
    templateUrl: './trips-itinerary-gallery-item.component.html',
    imports: [LazyPictureComponent],
})
export class TripsItineraryGalleryItemComponent implements OnInit {
    @Input() orientation: ImageOrientation;
    @Input() asset: Asset;
    featuredImageConfiguration: Configurations;
    constructor() {}

    ngOnInit(): void {
        this.featuredImageConfiguration = {
            [Stops.FALLBACK]: {
                image: this.asset,
                ratioHeight: 9,
                ratioWidth: 16,
                width: 800,
                width2x: 1200,
                width3x: 1600,
            },
            [Stops.BASE]: {
                image: this.asset,
                ratioHeight: 1,
                ratioWidth: 1,
                width: 800,
                width2x: 1200,
                width3x: 1600,
            },
            [Stops.SM]: {
                image: this.asset,
                ratioHeight: 1,
                ratioWidth: 1,
                width: 800,
                width2x: 1200,
                width3x: 1600,
            },
            [Stops.MD]: {
                image: this.asset,
                ratioHeight: 1,
                ratioWidth: this.orientation === 'square' ? 1 : 2,
                width: this.orientation === 'square' ? 800 : 1200,
                width2x: this.orientation === 'square' ? 1000 : 1400,
                width3x: this.orientation === 'square' ? 1200 : 1600,
            },
            [Stops.LG]: {
                image: this.asset,
                ratioHeight: 1,
                ratioWidth: this.orientation === 'square' ? 1 : 2,
                width: this.orientation === 'square' ? 800 : 1200,
                width2x: this.orientation === 'square' ? 1000 : 1400,
                width3x: this.orientation === 'square' ? 1200 : 1600,
            },
            [Stops.XL]: {
                image: this.asset,
                ratioHeight: 1,
                ratioWidth: this.orientation === 'square' ? 1 : 2,
                width: this.orientation === 'square' ? 800 : 1400,
                width2x: this.orientation === 'square' ? 1000 : 1600,
                width3x: this.orientation === 'square' ? 1200 : 1800,
            },
            [Stops.XXL]: {
                image: this.asset,
                ratioHeight: 1,
                ratioWidth: this.orientation === 'square' ? 1 : 2,
                width: this.orientation === 'square' ? 800 : 1400,
                width2x: this.orientation === 'square' ? 1000 : 1600,
                width3x: this.orientation === 'square' ? 1200 : 1800,
            },
        };
    }
}
